import * as R from 'ramda';
import { ForecastType, MetaType } from 'store/modules/Meta/types';

export const defineForecastsType = (
  forecastTypes: MetaType,

  forecasts: any
) => {
  if (!forecasts) return false;
  const preparedData = forecasts.map((forecast: ForecastType) => {
    const returnForecastInPercentage = Number(forecast.value) * 100;

    return {
      value: returnForecastInPercentage,
      name: R.find(R.propEq('value', forecast.forecast_type.toString()))(
        forecastTypes
      ).name,
      type: forecast.forecast_type
    };
  });

  return preparedData.sort((a: any, b: any) => a.type - b.type);
};
